(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function motionOff(){ return reduce; }
  function swipe(el, onLeft, onRight){
    var x0 = null;
    el.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    el.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 30) { (dx < 0 ? onLeft : onRight)(); }
    });
  }

  document.querySelectorAll('[data-t2]').forEach(function(bar){
    var msgs = [].slice.call(bar.querySelectorAll('.t2__msg'));
    var prog = bar.querySelector('.t2__prog span');
    var i = 0;
    function restart(){ bar.classList.remove('is-run'); void prog.offsetWidth; bar.classList.add('is-run'); }
    function gust(){ bar.classList.remove('is-gust'); void bar.offsetWidth; bar.classList.add('is-gust'); }
    function go(n){
      n = (n + msgs.length) % msgs.length;
      if (n === i) return;
      var out = msgs[i], inn = msgs[n];
      out.classList.remove('is-active'); out.classList.add('is-out'); out.inert = true;
      setTimeout(function(){
        out.style.transition = 'none'; out.classList.remove('is-out');
        void out.offsetWidth; out.style.transition = '';
      }, 520);
      inn.classList.add('is-active'); inn.inert = false;
      i = n;
      if (!motionOff()) gust();
      restart();
    }
    prog.addEventListener('animationend', function(){ go(i + 1); });
    swipe(bar, function(){ go(i + 1); }, function(){ go(i - 1); });
    restart();
  });

})();

  } catch(e) { console.error(e); }
})();
})();
